export const normalizeQuery = (query: string): string => {
  // Matches all standard and curly single quotes/apostrophes, plus backtick
  const cleanedText = query.replace(/['`‘’‛]/g, "'").trim();

  return cleanedText;
};
